export default "__VITE_ASSET__CpLzHiyQ__"